<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">Solicitar Projeto</p>
    </header>

    <section class="modal-card-body">
      <form @submit.prevent="requestProject">
        <b-loading
          :is-full-page="true"
          :active="isLoading"
          :can-cancel="false"
        ></b-loading>

        <b-field
          :label="
            request.eventInfo.projectCategory.length
              ? 'Categoria de projeto'
              : ''
          "
          label-position="on-border"
        >
          <b-taginput
            v-model="request.eventInfo.projectCategory"
            :data="opportunityBeingVisited.project.projectCategories"
            open-on-focus
            :keep-first="false"
            :allow-new="true"
            placeholder="Categoria de projeto"
          >
            <template slot-scope="props">
              {{ props.option }}
            </template>
          </b-taginput>
        </b-field>

        <b-field
          :label="
            request.eventInfo.studentsCourses.length
              ? 'Cursos dos estudantes *'
              : ''
          "
          label-position="on-border"
        >
          <b-taginput
            v-model="request.eventInfo.studentsCourses"
            :data="coursesArray"
            open-on-focus
            :keep-first="false"
            :allow-new="true"
            placeholder="Cursos dos estudantes *"
          >
            <template slot-scope="props">
              {{ props.option }}
            </template>
          </b-taginput>
        </b-field>

        <b-field
          :label="
            request.eventInfo.suggestedThemes.length
              ? 'Tema para o projeto'
              : ''
          "
          label-position="on-border"
        >
          <b-taginput
            v-model="request.eventInfo.suggestedThemes"
            :data="opportunityBeingVisited.project.themes"
            open-on-focus
            :keep-first="false"
            :allow-new="true"
            placeholder="Sugestões de Temas"
          >
            <template slot-scope="props">
              {{ props.option }}
            </template>
          </b-taginput>
        </b-field>

        <b-field
          :label="
            request.eventInfo.eventType !== '' ? 'Categoria da parceria' : ''
          "
          label-position="on-border"
        >
          <b-select expanded v-model="request.eventInfo.eventType">
            <option value="" disabled>Categoria da parceria</option>
            <option
              v-for="c in opportunityBeingVisited.project.categories"
              :value="c"
              :key="c"
            >
              {{ c }}
            </option>
          </b-select>
        </b-field>

        <b-field
          :label="request.eventInfo.eventName ? 'Nome do projeto *' : ''"
          label-position="on-border"
        >
          <b-input
            v-model="request.eventInfo.eventName"
            placeholder="Nome do projeto *"
          ></b-input>
        </b-field>

        <b-field
          :label="
            request.eventInfo.eventDescription ? 'Descrição do projeto *' : ''
          "
          label-position="on-border"
        >
          <b-input
            type="textarea"
            placeholder="Descreva brevemente o projeto, a parceria solicitada, seus benefícios e contrapartidas para as Empresas Mentoras."
            v-model="request.eventInfo.eventDescription"
          />
        </b-field>
        <span
          :style="descriptionLength >= 140 ? 'color: green' : 'color: red'"
          style="display: table; margin-left: auto;"
        >
          {{ descriptionLength }} > 140
        </span>

        <begin-end-date />

        <b-field label="Se desejar, anexe um material de suporte em PDF">
          <b-field>
            <div class="columns">
              <div class="column is-narrow">
                <button
                  type="button"
                  class="button is-empower-gray"
                  @click="$refs.pdf_project.click()"
                >
                  Anexar PDF (max. 5mb)
                </button>
                <input
                  id="pdf_project"
                  type="file"
                  ref="pdf_project"
                  style="display: none"
                  @change="handleFileUpload()"
                />
              </div>

              <div class="column">
                <p
                  v-if="filename"
                  :style="[!isMobile ? { 'margin-top': '0.4rem' } : null]"
                >
                  ✅ {{ filename }}&nbsp;
                  <a class="delete is-medium" @click="excludeFile"></a>
                </p>
              </div>
            </div>
          </b-field>
        </b-field>

        <b-field
          :label="
            request.eventInfo.organizationComments ? 'Algum comentário?' : ''
          "
          label-position="on-border"
        >
          <b-input
            type="textarea"
            placeholder="Algum comentário?"
            v-model="request.organizationComments"
          />
        </b-field>

        <b-field
          label="Termo de Contrapartidas *"
          custom-class="has-text-dark-grey"
        >
          <div class="field">
            <b-checkbox v-model="terms.form">
              Aceito enviar o formulário disponibilizado pela Empower a todos os
              participantes da ação.
            </b-checkbox>
            <br />
            <b-checkbox v-model="terms.photos" class="checkbox-bottom">
              Aceito enviar prints/fotos do projeto e coletar as devidas
              autorizações para uso de imagem dos participantes que aparecerem
              nos prints/fotos enviados.
            </b-checkbox>
            <br />
            <b-checkbox v-model="terms.post" class="checkbox-bottom">
              Aceito publicar um post na fanpage, insta ou linkedin da OE.
            </b-checkbox>
          </div>
        </b-field>

        <div class="has-text-centered">
          <button
            :disabled="pendencies.length || isLoading"
            class="button is-primary"
            :style="[windowWidth < 769 ? { marginBottom: 40 + 'px' } : null]"
          >
            Solicitar Projeto
          </button>
        </div>

        <Pendencies :pendencies="pendencies" />
      </form>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Cancelar
      </button>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { commom } from "../../../mixins/commom";
import { responsive } from "../../../mixins/responsive";
import { request } from "../../../mixins/request";
import { cursos } from "../../../assets/js/cursos";
import beginEndDate from "./date-time-options/BeginEndDate";
import Pendencies from "../../commom/Pendencies";

export default {
  mixins: [commom, responsive, request],

  components: {
    beginEndDate,
    Pendencies
  },

  props: ["advance"],

  data() {
    return {
      isLoading: false,

      request: {
        opportunity: null,
        requestType: "project",
        eventInfo: {
          suggestedThemes: [],
          eventType: "",
          eventName: "",
          eventDescription: "",
          projectCategory: [],
          dateOptions: {
            first: {
              date: null,
              start: null,
              end: null
            },
            second: {
              date: null,
              start: null,
              end: null
            }
          },
          studentsCourses: []
        },
        organizationComments: ""
      },

      pdf_project: "",
      filename: "",
      terms: {
        form: false,
        photos: false,
        post: false
      },
      coursesArray: []
    };
  },

  methods: {
    handleFileUpload() {
      this.filename = this.$refs.pdf_project.files[0].name;
      this.pdf_project = this.$refs.pdf_project.files[0];
    },

    excludeFile() {
      this.filename = "";
      this.pdf_lecture = "";
    },

    requestProject() {
      if (this.pdf_project.size > 5000000) {
        this.alertError({ message: "FILE_IS_TOO_LARGE" });
        return;
      }

      this.request.eventInfo.dateOptions.first.start = this.request.eventInfo.dateOptions.first.date;
      this.request.eventInfo.dateOptions.first.end = this.request.eventInfo.dateOptions.first.date;

      this.request.eventInfo.dateOptions.second.start = this.request.eventInfo.dateOptions.second.date;
      this.request.eventInfo.dateOptions.second.end = this.request.eventInfo.dateOptions.second.date;

      let formData = new FormData();
      formData.append("pdf_project", this.pdf_project);
      formData.append("request", JSON.stringify(this.request));

      this.isLoading = true;
      this.$store
        .dispatch("makeRequest", {
          to: "project",
          data: formData
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.$buefy.dialog.alert({
              title: "Solicitação de Projeto Recebida",
              message:
                "Sua solicitação será analisada e enviada para a empresa. A resposta pode levar algumas semanas. Em caso de dúvida, entre em contato conosco.",
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa",
              onConfirm: () => this.$parent.close(),
              onCancel: () => this.$parent.close()
            });
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    ...mapGetters(["opportunityBeingVisited"]),

    pendencies() {
      const pendencies = [];

      if (!this.terms.form || !this.terms.photos || !this.terms.post) {
        pendencies.push("Aceitar termos de contrapartidas");
      }

      if (this.request.eventInfo.projectCategory.length == 0) {
        pendencies.push("Categoria de projeto");
      }

      if (this.request.eventInfo.studentsCourses.length < 1) {
        pendencies.push("Informe os cursos dos estudantes");
      }

      if (this.request.eventInfo.suggestedThemes.length == 0) {
        pendencies.push("Sugestões de Temas");
      }

      if (this.request.eventInfo.eventType.length == 0) {
        pendencies.push("Categoria da parceria");
      }

      if (!this.request.eventInfo.eventName) {
        pendencies.push("Nome do projeto");
      }

      if (!this.request.eventInfo.eventDescription) {
        pendencies.push("Descrição do projeto");
      } else if (this.request.eventInfo.eventDescription.length < 140) {
        pendencies.push("A descrição precisa ter no mínimo 140 caracteres");
      }

      if (!this.request.eventInfo.dateOptions.first.date) {
        pendencies.push("Data de início");
      }

      if (!this.request.eventInfo.dateOptions.second.date) {
        pendencies.push("Data de término");
      }

      return pendencies;
    },

    descriptionLength() {
      return this.request.eventInfo.eventDescription.length;
    }
  },

  mounted() {
    this.coursesArray = cursos;
    
    this.request.opportunity = this.opportunityBeingVisited._id;
  }
};
</script>

<style scoped>
.modal-card-body {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.checkbox-bottom {
  padding-top: 0.5rem;
}
</style>
